module.exports = __webpack_public_path__ + "img/gratis_ongkir-grey.ce99cd3b.svg";